export default {
	id: 'SIMPLE_PREMIUM_24W_1194_24W_594',
	providers: {
		paltaMap: {
			USD: 'prd_N5HFCmyCbNSy',
		},
		primer: 'prd_N5HFCmyCbNSy',
	},
}
